export var polarToCartesian = function (centerX, centerY, radius, angleInDegrees) {
  return [centerX + radius * Math.cos(angleInDegrees * Math.PI / 180), centerY + radius * Math.sin(angleInDegrees * Math.PI / 180)];
};